export default __webpack_public_path__ + "static/media/renewable-energy-1.ad4bc7a6.png";